import React from 'react';
import { IconButton, SxProps, Theme } from '@mui/material';

interface ActionButtonProps {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  icon: React.ReactNode;
  backgroundColor?: string;
  color?: string;
  borderColor?: string;
  hoverBackgroundColor?: string;
  size?: number;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  icon,
  backgroundColor = '#FFFFFF',
  color = '#1B76D2',
  borderColor,
  hoverBackgroundColor = '#F5F5F5',
  size = 36,
}) => {
  const borderColorValue = borderColor || color;

  return (
    <IconButton
      onClick={onClick}
      sx={{
        backgroundColor,
        color,
        width: size,
        height: size,
        borderRadius: '12px',
        border: `2px solid ${borderColorValue}`,
        '&:hover': {
          backgroundColor: hoverBackgroundColor,
        },
      }}
    >
      {icon}
    </IconButton>
  );
};

